import type { EntityRegistryEntry } from '../types';

export const contractorConfig: EntityRegistryEntry = {
    fetchAttributes: ['Id', 'DisplayName', 'Email', 'JobCode', 'UserPrincipalName', 'Vendor'],
    listColumns: () => [
        {
            key: 'department',
            label: 'Department',
            sortable: true,
            render: (entity: any) => entity.Department || 'N/A'
        }
    ]
};
